export default function Logo({ dark = false, small = false }) {
  return (
    <img
      src={dark ? "/logo-white.png" : "/logo.png"}
      alt="SWM Consulting"
      className={`w-auto transition-transform duration-300 group-hover:-rotate-2 group-hover:scale-[1.03] ${
        small ? "h-20 md:h-24" : "h-24 md:h-28"
      }`}
      data-testid="logo-image"
    />
  );
}
